import { NativeModules } from 'react-native';

import { ExpoDevMenu } from './ExpoDevMenu.types';

export default NativeModules.ExpoDevMenu as ExpoDevMenu;
